import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MenuTreeService } from "../../../../services/sale/menuTreeService.ts";
import { MapPin } from "react-feather";

export default function PosLocationModal({ isOpen, onClose, onSelect }) {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    if (isOpen) loadLocations();
  }, [isOpen]);

  const loadLocations = async () => {
    try {
      const res = await MenuTreeService.getAllMenu();
      setLocations(res || []);
      console.log("Loaded Cost Centers:", res);
    } catch (err) {
      console.error("Failed to load cost centers:", err);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1055 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content p-4 rounded-4">

          <div className="modal-header border-0">
            <h5 className="modal-title w-100 text-center">Select Location</h5>
            <button className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body text-center">
            <div className="d-flex flex-wrap justify-content-center gap-4">

              {locations.map((cc) => (
                <div
                  key={cc.CostCenterID}
                  className="category-card shadow-sm p-3 text-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    //console.log("Selected CostCenter:", cc);
                    onSelect(cc);
                    onClose();
                  }}
                >
                  {/* MapPin Icon */}
                  <div>
                    <MapPin size={40} color="#ff3b30" />
                  </div>

                  <h6 className="mt-2">{cc.CostCenter}</h6>
                </div>
              ))}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

PosLocationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};
